module.exports = __webpack_public_path__ + "static/img/image_logo.718379e7.svg";